export default function ArrowsSVG({ cur, cardsReady, lines, isConnect }) {
  if (cur === 0) return null;

  return (
    <svg id="arrows-svg" key={cur} className={cardsReady && !isConnect ? "show" : ""}>
      <defs>
        <marker id="arrowTip" markerWidth="4" markerHeight="4" refX="2" refY="2" orient="auto">
          <circle cx="2" cy="2" r="1.5" fill="#fea082" opacity="0.8" />
        </marker>
      </defs>
      {['tl', 'tr', 'bl', 'br'].map((id) => (
        <line
          key={id}
          id={`line-${id}`}
          className="arrow-line"
          x1={lines[id]?.x1 || 0}
          y1={lines[id]?.y1 || 0}
          x2={lines[id]?.x2 || 0}
          y2={lines[id]?.y2 || 0}
          stroke="rgba(254,160,130,0.45)"
          strokeWidth="0.8"
          strokeDasharray="3,3"
          markerEnd="url(#arrowTip)"
        />
      ))}
    </svg>
  );
}
